import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database'; // Thêm Realtime Database
import { getFirestore, collection } from 'firebase/firestore'; // Giữ Firestore

export const firebaseApp = initializeApp({
    apiKey: "AIzaSyAJ4GZCT-ovXY8ayoubwBmncGBoggpNdIs",
    authDomain: "academy-93ca7.firebaseapp.com",
    databaseURL: "https://academy-93ca7-default-rtdb.firebaseio.com",
    projectId: "academy-93ca7",
    storageBucket: "academy-93ca7.firebasestorage.app",
    messagingSenderId: "556032543922",
    appId: "1:556032543922:web:4768a68674017238f08dab",
    measurementId: "G-0QQ04KKR00"
});

// Realtime Database
export const realtimeDb = getDatabase(firebaseApp);

// Firestore (cho các tính năng khác)
export const firestoreDb = getFirestore(firebaseApp);
export const messagesRef = collection(firestoreDb, 'messages');
export const notifiesRef = collection(firestoreDb, 'notifies');
export const commentsRef = collection(firestoreDb, 'comments');
export const articleCommentsRef = collection(firestoreDb, 'article_comments');
export const articleNotifiesRef = collection(firestoreDb, 'article_notifies');

export default firebaseApp;